module.exports = false;



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_library.js
// module id = 609
// module chunks = 0